<svg width="24" height="24" viewBox="0 0 24 24">
	<circle cx="12" cy="12" r="10" fill="#000000"/>
	<circle cx="12" cy="12" r="8" fill="#FFFFFF"/>
	<circle cx="12" cy="12" r="5" fill="#000000"/>
	<circle cx="12" cy="12" r="3" fill="#FFFFFF"/>
	<circle cx="12" cy="12" r="2" fill="#000000"/>
</svg>
